var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { unstable_useDateField as useDateField, } from '@mui/x-date-pickers/DateField';
import * as React from 'react';
import { DateFormControl } from './DateFormControl';
/**
 * Custom field component used in slot of a date picker. It uses our custom DateFormControl component.
 */
export function DateField(props) {
    var externalInputRef = props.inputRef, slots = props.slots, slotProps = props.slotProps, textFieldProps = __rest(props, ["inputRef", "slots", "slotProps"]);
    var response = useDateField({
        props: textFieldProps,
        inputRef: externalInputRef,
    });
    return React.createElement(DateFormControl, __assign({}, response));
}
